import { useEffect } from 'react';
import { useComponentProps } from 'navigation-components/platform/hooks';
import { callingComponentDef } from 'navigation-components/config';
export const usePassCallingComponentPositionProps = () => {
  const updateCallingComponentProps = useComponentProps(callingComponentDef);
  const documentBodyCoordinates = document.body.getBoundingClientRect();
  const documentBodyWidth = documentBodyCoordinates.width;
  const callIcon = document.getElementById('calling-remote-toggle');
  const coordinates = callIcon && callIcon.getBoundingClientRect();
  const left = coordinates && coordinates.left;
  const rightOffset = left && documentBodyWidth - left - 216;
  const top = coordinates && coordinates.top;
  const topOffset = top && top + 31;
  useEffect(() => {
    updateCallingComponentProps({
      iframeRightOffset: rightOffset,
      iframeTopOffset: topOffset
    });
  }, [left, rightOffset, topOffset, updateCallingComponentProps]);
};